module.exports = __webpack_public_path__ + "media/images/pic/brodno/team-b138f030588814af756ebc6348627660.jpg";